<div [class.drawer-open]="show">
  <div
    class="drawer-overlay"
    (click)="toggle()"
    [class.relative-to-parent]="relativeToParent"
  ></div>
  <nav
    class="drawer-content"
    [attr.aria-hidden]="!show"
    [class.relative-to-parent]="relativeToParent"
    [ngClass]="'placement-' + placement"
  >
    <ng-content></ng-content>
  </nav>
</div>
